import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const EventSlider = () => {
    const autoplayPlugin = (slider) => {
        let timeout;
        let mouseOver = false;

        function clearNextTimeout() {
            clearTimeout(timeout);
        }

        function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
                slider.next();
            }, 2500);
        }

        slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
                mouseOver = false;
                nextTimeout();
            });
            nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    };

    const [sliderRef] = useKeenSlider(
        {
            loop: true,
            slides: {
                perView: 2,
                spacing: 16,
            },
            breakpoints: {
                '(min-width: 640px)': {
                    slides: { perView: 2, spacing: 20 },
                },
                '(min-width: 1024px)': {
                    slides: { perView: 2, spacing: 24 },
                },
            },
        },
        [autoplayPlugin]
    );

    const images = [
        "/assets/event/item1.png",
        "/assets/event/item2.png",
        "/assets/event/item3.png",
        "/assets/event/item4.png",
        "/assets/event/item5.png",
        "/assets/event/item6.png",
        "/assets/event/item7.png",
        "/assets/event/item8.png"
    ];

    return (
        <div className="w-full max-w-[1440px] mx-auto px-6 lg:px-[80px] py-12">
            <div ref={sliderRef} className="keen-slider">
                {images.map((src, index) => (
                    <div key={index} className="keen-slider__slide">
                        <div className='flex justify-center items-center'>
                            <img
                                src={src}
                                alt={`Event Item ${index + 1}`}
                                className="w-full h-auto lg:h-[300px] object-cover rounded-xl"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EventSlider;